export const API_BASE =
  import.meta.env.VITE_API_URL ?? "https://api.iskconpunebcec.com";

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public body?: unknown
  ) {
    super(message);
    this.name = "ApiError";
  }
}

type RequestOptions = {
  method?: string;
  body?: unknown;
  adminPassword?: string | null;
  /** @deprecated Use adminPassword */
  apiKey?: string | null;
  token?: string | null;
  params?: Record<string, string | undefined>;
};

export async function apiRequest<T>(
  path: string,
  options: RequestOptions = {}
): Promise<T> {
  const { method = "GET", body, adminPassword, apiKey, token, params } = options;
  const password = adminPassword ?? apiKey;

  const url = new URL(path.startsWith("http") ? path : `${API_BASE}${path}`);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined) url.searchParams.set(k, v);
    });
  }

  const headers: Record<string, string> = {
    Accept: "application/json",
  };

  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  if (password) {
    headers["X-Admin-Password"] = password;
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url.toString(), {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    cache: "no-store",
  });

  if (!res.ok) {
    let detail: unknown;
    try {
      detail = await res.json();
    } catch {
      detail = await res.text();
    }
    const message = extractApiDetail(detail) || `Request failed (${res.status})`;
    throw new ApiError(message, res.status, detail);
  }

  if (res.status === 204) {
    return undefined as T;
  }

  return res.json() as Promise<T>;
}

export function adminAuthHeaders(adminPassword: string): Record<string, string> {
  return { "X-Admin-Password": adminPassword, Accept: "text/csv" };
}

export function extractApiDetail(body: unknown): string {
  if (typeof body === "string" && body.trim()) return body;
  if (Array.isArray(body)) {
    return body
      .map((item) => extractApiDetail(item))
      .filter(Boolean)
      .join(" ");
  }
  if (body && typeof body === "object") {
    const obj = body as { detail?: unknown; msg?: unknown; message?: unknown };
    if (obj.detail !== undefined) return extractApiDetail(obj.detail);
    if (typeof obj.msg === "string" && obj.msg.trim()) return obj.msg;
    if (typeof obj.message === "string" && obj.message.trim()) return obj.message;
  }
  return "";
}
